import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { IAnnex6V2Store, TAnnex6V2HistoryFilters } from './@types';
import { EAnnex6V2Actions } from './actions';

const annex6V2Selectors = {
    _getStore(store: IStore) {
        return store.app.annex6V2;
    },
    getHistoryList(store: IAnnex6V2Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IAnnex6V2Store): TAnnex6V2HistoryFilters {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: IAnnex6V2Store) {
        return jobSelectors.getJobStatus(store, EAnnex6V2Actions.HISTORY_LOAD);
    },
};
export default annex6V2Selectors;
